import { Message } from 'element-ui'
import cloneDeep from 'lodash.clonedeep';
import { sendMessage } from "~/utils/event";
import { checkInIframe } from "~/utils/dom";
import { getNeedParamsFormRouteParams, getParamsFromUrl } from '~/utils'
import { SiteEnum } from "~/enums/siteEnum";
import EventBus from "~/utils/eventBus";
import { PageEnum, PageNameEnum, NativePaths } from "~/enums/pageEnum";

function SitePage() {
  this.list = []
  this.info = {}
  this.current = ''
  this.isProd = false
  this.$bus = new EventBus()
}

SitePage.prototype.append = function (pageItem) {
  const current = this.list.find(item => item.id === pageItem.id)
  if (!current) {
    this.list.push(pageItem)
  }
}

SitePage.prototype.setCurrent = function (data) {
  this.current = data
}

SitePage.prototype.get = function (link) {
  const current = this.list.find(item => item.link === link)
  if (current) {
    return cloneDeep(current)
  } else {
    Message.error('页面信息未找到，或链接已被修改！')
    throw new Error('Page Not Found')
  }
}

SitePage.prototype.setInfo = function (data) {
  this.info = data
}

SitePage.prototype.updateItem = function (pageItem) {
  const index = this.list.findIndex(item => item.id === pageItem.id)
  if (index > -1) {
    const newItem = Object.assign(cloneDeep(this.list[index]), pageItem)
    this.list.splice(index, 1, newItem)
  }
}

SitePage.prototype.toHome = function () {
  this.to('主页')
}

SitePage.prototype.toShopCart = async function () {
  const $route = window.$nuxt.$route
  const [headNative, siteId, pageId, langId] = getParamsFromUrl($route.path, sitePage.isProd)
  const $router = window.$nuxt.$router
  const isPreview = headNative === PageNameEnum.PREVIEW

  if (isPreview) {
    let url = `/preview/${siteId}/shop-cart/${langId}`
    await $router.push({
      path: url,
      query: $route.query
    })
  } else if (sitePage.isProd) {
    const url = `/shop-cart/${langId}`
    await $router.push({
      path: url,
      query: $route.query
    })
  }
}

SitePage.prototype.toCoupon = async function () {
  const $route = window.$nuxt.$route
  const params = getNeedParamsFormRouteParams($route.params, sitePage.isProd)
  const $router = window.$nuxt.$router
  const isPreview = $route.name === 'preview-sid-lang-pageid'
  const lang = params.lang || params.pageid
  if (isPreview) {
    const url = `/preview/${params.sid}${PageEnum.COUPON}/${PageEnum.COUPON.includes(lang) ? '' : lang}`
    await $router.push(url)
  } else if (sitePage.isProd) {
    const url = `${PageEnum.COUPON}/${lang}`
    await $router.push(url)
  }
}

SitePage.prototype.to = async function (to) {
  if (!to) return
  const editMode = window.__site_builder_edit_init
  const $router = window.$nuxt.$router
  const $route = window.$nuxt.$route
  const inIframe = checkInIframe()
  const current = sitePage.list.find(item => (item.name === to) || item.link === to) || {}
  const toPage = async () => {
    let path = $route.fullPath
    const [headNative, siteId, pageId, langId] = getParamsFromUrl(path, sitePage.isProd)
    NativePaths.forEach(item => { path = path.replace(item, '') })
    const isToHome = current.id === SiteEnum.BASE_PAGE
    const isHead = !pageId
    if (isHead) {
      const noQueryUrl = sitePage.isProd ? `/${current.link}/${langId}` : `/preview/${siteId}/${current.link}/${langId}`
      path = isToHome ? path : noQueryUrl
    } else {
      path = isToHome ? (path.includes(`/${pageId}`) ? path.replace(`/${pageId}`, '') : path.replace(pageId, '')) : path.replace(pageId, current.link)
    }
    await $router.push(path)
  }
  const openUrl = () => {
    window.open(to, '_blank')
  }
  const changeSitePage = () => {
    sitePage.$bus.$emit('change-page', current.link)
  }

  const isUrl = to.includes('http')
  if (isUrl) {
    openUrl()
  } else if (inIframe && editMode) {
    await sendMessage({ type: 'changeRouteQuery', data: current.link })
    changeSitePage()
  } else if (!inIframe && editMode) {
    await $router.push({ query: { page: current.link } })
    changeSitePage()
  } else {
    await toPage()
  }
}

const sitePage = new SitePage()

export default sitePage
